import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFilterPipe } from './searchFilter.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SearchFilterPipe],
  exports: [SearchFilterPipe]
})
export class SearchFilterModule {}

